import axiosInstance from 'services/AuthHeader';

const USER_AUTHENTICATION = 'authentication';

// TODO: Do we want to migrate this to the redux store?ß
export function getAuth() {
  return JSON.parse(sessionStorage.getItem(USER_AUTHENTICATION));
}

export function setAuth(auth) {
  sessionStorage.setItem(USER_AUTHENTICATION, auth);
}

export function destroyAuth() {
  sessionStorage.removeItem(USER_AUTHENTICATION);
}

export function resetAppState() {
  destroyAuth();
  window.location = '/portal';
}

export function signOut() {
  return axiosInstance
    .post('/api/auth/logout')
    .catch((_) => 'ignore: we are logging out.')
    .finally(resetAppState);
}
